'use strict';

var _ = require('lodash');
var StepResponsibilityController = function StepResponsibilityController($scope, cellRendererService, ScheduleChangeConstants, FeatureToggleService, App, UserSecureService) {
  $scope.userIdList = _.map(_.filter(App.userList, function (User) {
    return User.isActive && !User.isSabreEmployee;
  }), function (User) {
    return {
      id: User.getUserId(),
      label: User.getDisplayName()
    };
  });
  $scope.currentUserId = UserSecureService.getUserId();
  $scope.isCurrentUserAnAdmin = UserSecureService.isCurrentUserAnAdmin() || UserSecureService.isUserSystemOwner();
  $scope.stepTitle = {
    'markets': 'Responsibility',
    'legs': 'Leg Responsibility'
  };
  function filterByFeature(entry) {
    if (entry.showIfFeature && FeatureToggleService.isDisabled(entry.showIfFeature) || entry.hideIfFeature && FeatureToggleService.isEnabled(entry.hideIfFeature)) {
      return false;
    }
    return true;
  }
  var columnDefs = {};
  var marketsColumnDefs = [{
    headerName: 'Market Name',
    field: 'market',
    cellRenderer: cellRendererService.marketCellRenderer,
    width: 240
  }, {
    headerName: 'Assignee',
    field: 'assignee',
    cellRenderer: _.wrap({
      isUserAdmin: $scope.isCurrentUserAnAdmin,
      currentUserId: $scope.currentUserId,
      model: $scope.scheduleChange,
      currentUser: UserSecureService.getCurrentUser()
    }, cellRendererService.assigneeInputCellRenderer),
    width: 360
  }];
  var legsColumnDefs = [{
    headerName: 'Leg',
    field: 'leg',
    cellRenderer: cellRendererService.marketCellRenderer,
    width: 120
  }, {
    headerName: 'Assignee',
    field: 'assignee',
    cellRenderer: _.wrap({
      isUserAdmin: $scope.isCurrentUserAnAdmin,
      currentUserId: $scope.currentUserId,
      model: $scope.scheduleChange,
      currentUser: UserSecureService.getCurrentUser()
    }, cellRendererService.assigneeLegInputCellRenderer)
  }];
  marketsColumnDefs = _.filter(marketsColumnDefs, filterByFeature);
  columnDefs[ScheduleChangeConstants.ENTITIES.MARKETS] = marketsColumnDefs;
  columnDefs[ScheduleChangeConstants.ENTITIES.LEGS] = legsColumnDefs;
  $scope.gridOptions = _.defaults({
    columnDefs: columnDefs[$scope.wizardShown],
    rowData: $scope.scheduleChange.getStepResponsibleSignificantEntities()
  }, $scope.defaultGridOptions);
  $scope.stepEntered = function (event, stepTitle) {
    if (stepTitle === $scope.stepTitle[$scope.wizardShown]) {
      $scope.gridOptions.rowData = $scope.scheduleChange.getStepResponsibleSignificantEntities();
      $scope.gridOptions.api.onNewRows();
      $scope.calculateGridHeight();
      $scope.gridOptions.api.sizeColumnsToFit();
    }
  };
  $scope.calculateGridHeight = function () {
    // Adding 1px to height to get rid of the vertical scrollbar
    $scope.height = $scope.defaultGridOptions.calculateGridHeight($scope.gridOptions.rowData.length, 10) + 1;
  };
};
StepResponsibilityController.$inject = ['$scope', 'CellRendererService', 'ScheduleChangeConstants', 'FeatureToggleService', 'App', 'UserSecureService'];
module.exports = StepResponsibilityController;